import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
	ACCESSIBILITY_TYPES_IVV,
	DESTINATIONS,
	DestroyableComponent,
	EXPERIENCES,
	FACILITIES_ACCOMMODATION_FOR_FILTERS,
	FACILITIES_DAYTRIP,
	INSIDE_OUTSIDE,
	MEALS_IVVA,
	OffersType,
	OVERNIGHT_STAYS,
	PaymentOption,
	ROOM_TYPES,
	TARGET_AUDIENCES,
	TRANSPORTATIONS,
} from '@toevla-webapplications/core';
import { IvvaStore } from '../../../../store/store.model';
import { FilterBoxComponent } from '../filter-box/filter-box.component';
import { FilterConfig } from '../../../../shared/filter-config.model';
import { takeUntil } from 'rxjs';
import { THEMES } from '../../../../services/offers/theme-type.enum';
import { CONDITION_TYPES_EXCLUSIVE, CONDITION_TYPES_INCLUSIVE } from '../../../../services/offers/condition-type.enum';

@Component({
	selector: 'ivva-side-filter',
	templateUrl: './side-filter.component.html',
	styleUrls: ['./side-filter.component.scss'],
	imports: [FilterBoxComponent],
})
export class SideFilterComponent extends DestroyableComponent implements OnInit {
	configs: FilterConfig[];

	private store = inject(Store<IvvaStore>);

	ngOnInit() {
		this.store
			.select('offers', 'type')
			.pipe(takeUntil(this.destroyed$))
			.subscribe((type) => {
				this.configs = this.getFilters(type).map((f) => {
					return {
						...f,
						tracker: `${type}.${f.name}`,
					};
				});
			});
	}

	private getFilters(type: OffersType): FilterConfig[] {
		const accessibility = {
			name: 'impairments',
			title: 'HOME.SIDE_FILTER.ACCESSIBILITY',
			base: 'ACCESSIBILITY_TYPE',
			options: ACCESSIBILITY_TYPES_IVV,
		};

		switch (type) {
			case OffersType.DAYTRIP:
				return [
					{
						name: 'paymentMethod',
						title: 'Hoe betalen bij individuele boeking',
						base: 'PAYMENT_TIME',
						options: [PaymentOption.PAYMENT_UPFRONT, PaymentOption.PAYMENT_ON_ARRIVAL],
					},
					{
						name: 'insideOutside',
						title: 'HOME.SIDE_FILTER.INSIDE_OUTSIDE',
						base: 'INSIDE_OUTSIDE',
						options: INSIDE_OUTSIDE,
					},
					{
						name: 'targetAudiences',
						title: 'HOME.SIDE_FILTER.TARGET_AUDIENCE',
						base: 'TARGET_AUDIENCE',
						options: TARGET_AUDIENCES,
					},
					accessibility,
					{
						name: 'facilities',
						title: 'HOME.SIDE_FILTER.FACILITY',
						base: 'FACILITY',
						options: FACILITIES_DAYTRIP,
					},
				];
			case OffersType.ACCOMMODATION:
				return [
					{
						name: 'meals',
						title: 'HOME.SIDE_FILTER.MEALS',
						base: 'MEAL_OPTION',
						options: MEALS_IVVA,
					},
					{
						name: 'experiences',
						title: 'HOME.SIDE_FILTER.EXPERIENCES',
						base: 'EXPERIENCE',
						options: EXPERIENCES,
					},
					{
						name: 'roomtypes',
						title: 'HOME.SIDE_FILTER.ROOM_TYPE',
						base: 'ROOM_TYPE',
						options: ROOM_TYPES,
					},
					{
						name: 'facilities',
						title: 'HOME.SIDE_FILTER.FACILITY',
						base: 'FACILITY',
						options: FACILITIES_ACCOMMODATION_FOR_FILTERS,
					},
					accessibility,
				];
			case OffersType.ORGANIZED_HOLIDAY:
				return [
					{
						name: 'overnightStays',
						title: 'HOME.SIDE_FILTER.OVERNIGHT_STAY',
						base: 'OVERNIGHT_STAY',
						options: OVERNIGHT_STAYS,
					},
					{
						name: 'destinations',
						title: 'HOME.SIDE_FILTER.DESTINATION',
						base: 'DESTINATION',
						options: DESTINATIONS,
					},
					{
						name: 'transportations',
						title: 'HOME.SIDE_FILTER.TRANSPORTATION',
						base: 'TRANSPORTATION',
						options: TRANSPORTATIONS,
					},
					{
						name: 'themes',
						title: 'HOME.SIDE_FILTER.THEME',
						base: 'THEME',
						options: THEMES,
					},
					{
						name: 'exclusive',
						title: 'HOME.SIDE_FILTER.EXCLUSIVE',
						base: 'CONDITION_TYPE',
						options: CONDITION_TYPES_EXCLUSIVE,
					},
					{
						name: 'inclusive',
						title: 'HOME.SIDE_FILTER.INCLUSIVE',
						base: 'CONDITION_TYPE',
						options: CONDITION_TYPES_INCLUSIVE,
					},
				];
		}
	}
}
